export function hasRunningAsyncTasks(tasks) {
  return Array.isArray(tasks) && tasks.some(task => task?.status === 'Running')
}
